export const FIELDS = [
  {
    name: 'rut',
    label: 'RUT',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'serialNumber',
    label: 'N° de documento cédula de identidad',
    disabled: false,
    required: true,
    info: true,
  },
  {
    name: 'clientName',
    label: 'Nombre completo',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    label: 'Correo',
    disabled: false,
    required: true,
  },
  {
    name: 'motiveClient',
    inputType: 'select',
    label: 'Derecho a ejercer',
    value: '',
    disabled: false,
    required: true,
  },
  {
    inputType: 'messages',
    hidden: true,
  },
  {
    name: 'comment',
    multiline: true,
    rows: 4,
    label: 'Escribir comentario',
    textArea: 'Escribir comentario',
    disabled: false,
    required: false,
  },
];
